/* LBN Audio Designs — theme scripts (nav, reveal, config toggle, variant picker, cart count) */
(function () {
  'use strict';

  // ---------- Mobile nav toggle ----------
  document.querySelectorAll('[data-lbn-nav-toggle]').forEach(function (toggle) {
    var mobileNav = document.querySelector('[data-lbn-mobile-nav]');
    if (!mobileNav) return;
    toggle.addEventListener('click', function () {
      var open = mobileNav.hasAttribute('data-open');
      if (open) {
        mobileNav.removeAttribute('data-open');
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        mobileNav.setAttribute('data-open', '');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // ---------- Reveal on scroll (with 1.5s no-JS-safe failsafe) ----------
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var reveals = document.querySelectorAll('.lbn-reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('lbn-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lbn-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      reveals.forEach(function (el) { el.classList.add('lbn-in'); });
    }, 1500);
  }

  // ---------- Single/Dual config toggle on plan cards ----------
  document.querySelectorAll('.lbn-plan-card').forEach(function (card) {
    var toggle = card.querySelector('.lbn-config-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('.lbn-cfg');
      if (!btn) return;
      toggle.querySelectorAll('.lbn-cfg').forEach(function (b) {
        b.classList.toggle('active', b === btn);
        b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
      });
      var isDual = btn.getAttribute('data-cfg') === 'dual';
      var imgSingle = card.querySelector('.img-single');
      var imgDual = card.querySelector('.img-dual');
      if (imgSingle && imgDual) {
        imgSingle.hidden = isDual;
        imgDual.hidden = !isDual;
      }
    });
  });

  // ---------- Product variant picker ----------
  document.querySelectorAll('[data-lbn-product]').forEach(function (root) {
    var variantsJson = document.getElementById('lbn-variants-' + root.getAttribute('data-lbn-product'));
    if (!variantsJson) return;
    var variants;
    try { variants = JSON.parse(variantsJson.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-lbn-variant-id]');
    var priceEl = root.querySelector('[data-lbn-price]');
    var atcBtn = root.querySelector('[data-lbn-atc]');
    var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    var media = root.querySelectorAll('.lbn-product-gallery .lbn-plan-media img');
    var optButtons = {};
    root.querySelectorAll('.lbn-opt').forEach(function (btn) {
      var name = btn.getAttribute('data-option-name');
      var value = btn.getAttribute('data-option-value');
      optButtons[name] = optButtons[name] || [];
      optButtons[name].push({ btn: btn, value: value });
    });

    function selected() {
      var sel = {};
      Object.keys(optButtons).forEach(function (name) {
        var active = optButtons[name].filter(function (o) { return o.btn.classList.contains('active'); })[0];
        sel[name] = active ? active.value : null;
      });
      return sel;
    }

    function findVariant() {
      var sel = selected();
      var names = Object.keys(sel);
      return variants.filter(function (v) {
        return names.every(function (n) { return v.options[names.indexOf(n)] === sel[n]; });
      })[0];
    }

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function update() {
      var variant = findVariant();
      Object.keys(optButtons).forEach(function (name) {
        optButtons[name].forEach(function (o) {
          var test = selected();
          test[name] = o.value;
          var names = Object.keys(test);
          var match = variants.some(function (v) {
            return names.every(function (n) { return test[n] === null || v.options[names.indexOf(n)] === test[n]; });
          });
          o.btn.disabled = !match;
        });
      });
      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (priceEl && variant.price != null) priceEl.textContent = money(variant.price);
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
          atcBtn.textContent = variant.available ? atcBtn.getAttribute('data-atc-label') || 'Add to cart' : 'Sold out';
        }
        var sel = selected();
        var cfgOption = Object.keys(sel).filter(function (n) { return /single|dual/i.test(sel[n] || ''); })[0];
        if (cfgOption && media.length > 1) {
          var isDual = /dual/i.test(sel[cfgOption] || '');
          media[0].hidden = isDual;
          media[1].hidden = !isDual;
        }
      }
    }

    root.querySelectorAll('.lbn-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.getAttribute('data-option-name');
        optButtons[name].forEach(function (o) { o.btn.classList.toggle('active', o.btn === btn); });
        update();
      });
    });
    update();
  });

  // ---------- Cart count badge refresh ----------
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('[data-lbn-cart-count]').forEach(function (el) {
        el.textContent = c.item_count;
      });
    }).catch(function () {});
  }
  document.addEventListener('cart:refresh', refreshCartCount);
  document.addEventListener('DOMContentLoaded', refreshCartCount);
})();
